<template>
<h3 class="text-white text-2xl font-bold uppercase mb-3">Providers</h3>
<div class="overflow-auto h-screen 2xl:w-3/4 grid gap-3 xl:grid-cols-8 md:grid-cols-4 sm:grid-cols-3">
	<div class="mr-2 mw-210px" v-if="this.hasOneProviderWithAdminRole == false">
        <div class="media-item">
        	<a href="##" @click.prevent="toggleCreateProviderModal">
        		<div class="heading">
        			<div>Add</div>
        		</div>
        		<div class="content">
        			<i class="plus-large"></i>
        		</div>
        	</a>
        </div>
    </div>

    <div v-for="provider in data" class="mr-2 mw-210px">
        <div class="media-item">
        	<a href="##" @click.prevent="(e) => toggleEditProviderModal(e, provider)">
        		<div class="heading">
                    <div class="badge-egg-blue">{{ provider.auth_user_role }}</div>
        			<div>{{ provider.name }}</div>
        		</div>
        		<div class="content">
        			<img v-if="provider.logo" class="object-contain w-full h-full" :src="provider.logo">
        		</div>
        	</a>
        </div>
    </div>

</div>
</template>

<script>
export default {
    props: {
        toggleCreateProviderModal: Function,
        data: Array,
        toggleEditProviderModal: Function,
    },
    data(){
        return {
            hasOneProviderWithAdminRole: this.hasUserOneProviderWithAdminRole(),
        }
    },
    methods: {
        hasUserOneProviderWithAdminRole(){
            if(this.$page.props.providers.data.filter(prov => prov.auth_user_role == 'admin').length)
            {
                return  true
            } else {
                return false
            }
        }
    },
    updated(){
        this.hasOneProviderWithAdminRole = this.hasUserOneProviderWithAdminRole();
    }
}
</script>